import { API_INSTANCE, buildURLWithState, fullBuildURL } from 'src/features/utils';

export async function saveNewIntegrationApi({ integrationType, apiKey }) {
  return await API_INSTANCE.post(fullBuildURL(`/api/v1/${integrationType}/users`), {
    api_key: apiKey,
  });
}

export async function integrationDisconnectApi(
  state: unknown,
  data: { userId: string; value: unknown }
) {
  return await API_INSTANCE.put<unknown>(
    buildURLWithState(state, `/api/v1/config/disconnect`),
    data
  );
}

export async function getOrganizationApi(state: unknown, type?: 'linkedIn' | 'all') {
  const url = () => {
    if (type === 'linkedIn') return fullBuildURL(state, `/api/v1/dashboard/linkedin/pages`);
    return fullBuildURL(state, `/api/v1/users/organizations`);
  };
  return await API_INSTANCE.get<unknown>(url());
}
